import IApplicationState from 'app/types/state';

export function getCart(state: IApplicationState) {
  return {
    ...state.cart,
  };
}
